import CircleSolidSmall from '../media/CircleSolidSmall.svg';
import DiamondSolidSmall from '../media/DiamondSolidSmall.svg';
import TriangleDownSolidSmall from '../media/TriangleDownSolidSmall.svg';
import TriangleUpSolidSmall from '../media/TriangleUpSolidSmall.svg';
import SquareSolidSmall from '../media/SquareSolidSmall.svg';

export const competitionCardStyle = {
  '.competition-card': {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 16,
    '& .vnext-legend-labels-container': {
      paddingLeft: 10,
      paddingTop: 10,

      '& ul': {
        display: 'flex',
        listStyle: 'none',
        paddingLeft: 0,

        '& li': {
          minWidth: 60,

          '& .legend-label': {
            height: 20,
            paddingLeft: '15PX !important',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'left',
            backgroundSize: '12px 20px',
            marginRight: 5,
            marginLeft: 5,
            marginTop: 1,
            cursor: 'pointer',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          },

          '& .legend-label.disabled': {
            opacity: '50%',
          },
        },
        '& li:nth-child(1) .legend-label': {
          backgroundImage: `url("${CircleSolidSmall}")`,
        },
        '& li:nth-child(2) .legend-label': {
          backgroundImage: `url("${DiamondSolidSmall}")`,
        },
        '& li:nth-child(3) .legend-label': {
          backgroundImage: `url("${TriangleDownSolidSmall}")`,
        },
        '& li:nth-child(4) .legend-label': {
          backgroundImage: `url("${TriangleUpSolidSmall}")`,
        },
        '& li:nth-child(5) .legend-label': {
          backgroundImage: `url("${SquareSolidSmall}")`,
        },
      },
    },
    '& .highcharts-container': {
      overflow: 'visible !important',

      '& .chart-tooltip': {
        fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
        fontSize: 14,
        position: 'absolute',
        whiteSpace: 'nowrap',
        color: 'rgb(51, 51, 51)',
        padding: 15,
        display: 'block',
        boxShadow: '0 3.2px 7.2px 0 rgba(0,0,0,.132), 0 0.6px 1.8px 0 rgba(0,0,0,.108)',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        '@supports (backdrop-filter: blur(60px))': {
          backdropFilter: 'blur(60px)',
          backgroundColor: 'rgba(255, 255, 255, 0.25)',
        },

        '& .segment-wrapper': {
          marginBottom: 10,
        },

        '& .tooltip-name': {
          marginLeft: 6,
          maxWidth: 400,
          wordWrap: 'break-word',
          whiteSpace: 'normal',
        },
      },
    },
  },
  '.competition-card .selector-container': {
    float: 'left',
    marginBottom: 12,
  },
  '.competition-card .competition_action .competition_clickLink': {
    flex: '0 0 auto',
  },
  '.competition-card .competition-graph': {
    flex: '1',
  },
  '.competition-card .tile-content .error-msg': {
    paddingTop: 100,
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
  },
  '.competition-card .competition-empty': {
    height: 234,
    textAlign: 'center',
    display: 'inline-block',
    width: '100%',
  },
  '.competition-card .competition-empty .competition-empty-text': {
    position: 'relative',
    top: '50%',
    W: 'translateY(-50%)',
    M: 'translateY(-50%)',
    transform: 'translateY(-50%)',
  },
  '.competition-card-in-toolbar': {
    order: '2',
    margin: '0 5px 0 10px',
    display: 'flex',
    alignItems: 'center',
  },
  '.competition-card .selector-container, .competition-card-in-toolbar .selector-container': {
    lineHeight: 'normal !important',
    fontWeight: '400',
    fontSize: '14px !important',
  },
  '.competition-card .selector-container .btn, .competition-card-in-toolbar .selector-container .btn': {
    border: '0',
    padding: 1,
    fontWeight: 'normal',
  },
  '.competition-card .selector-container .truncated, .competition-card-in-toolbar .selector-container .truncated': {
    marginRight: 5,
  },
  '.competition-card .domain-selector-header, .competition-card-in-toolbar .domain-selector-header': {
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 10,
  },
  '.selector-v2': {
    width: 300,
    padding: '0',
  },
  '.selector-v2 .selector__filter': {
    padding: 10,
  },
  '.selector-v2 .selector__main': {
    width: '100%',
  },
  '.selector-v2 .selector__filter .search-box__input[type="text"]': {
    width: '100%',
  },
  '.selector-v2 .selector__data-host': {
    position: 'relative',
    minHeight: 40,
  },
  '.selector-v2 .selector__data-progress-backdrop': {
    backgroundColor: 'white',
    bottom: '0',
    left: '0',
    opacity: '0.8',
    position: 'absolute',
    right: '0',
    top: '0',
  },
  '.selector-v2 .selector__data-progress-overlay': {
    backgroundColor: 'white',
    height: 40,
    left: '50%',
    lineHeight: '40px',
    marginLeft: -60,
    marginTop: -20,
    overflowX: 'hidden',
    overflowY: 'hidden',
    position: 'absolute',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    top: '50%',
    width: 120,
    whiteSpace: 'pre',
  },
  '.selector-v2 .selector__data-progress-overlay span': {
    verticalAlign: 'middle',
  },
  '.selector-v2 .selector__data': {
    maxHeight: 360,
    overflowY: 'auto',
    position: 'relative',
  },
  '.selector-v2 .selector__data-progress-overlay .progress__icon': {
    display: 'inline-block',
    backgroundRepeat: 'no-repeat',
    width: 40,
    height: 30,
  },
  '.selector-v2 .selector__grid-host .table.grid': {
    marginBottom: 0,
    cursor: 'pointer',
    overflow: 'hidden',
  },
  '.selector-v2 .selector__grid-host .table.grid > tbody > tr > td.table__cell--icon': {
    width: 30,
    paddingLeft: 7,
  },
  '.selector-v2 .selector__grid-host .table.grid > tbody > tr:hover': {
    backgroundColor: '#f3f2f1',
  },
  '.selector-v2 .selector__grid-host .table.grid > thead > tr:hover': {
    backgroundColor: '#f3f2f1',
  },
  '.selector-v2 .selector__grid-host td': {
    whiteSpace: 'pre',
  },
  '.selector-v2 .selector__list-checkbox, .selector-v2 .column-tri-state-checkbox': {
    height: '20px',
    width: '20px',
    '& > span:after': {
      display: 'inline-block',
      backgroundColor: '#fff',
      border: '1px solid rgba(155, 155, 155, 0.57)',
      borderRadius: '2px',
      color: 'transparent',
      content: '"\\E73E"',
      height: '20px',
      width: '20px',
      fontFamily: 'MsAds MDL2 Assets',
      fontSize: '16px',
      fontWeight: '400',
      paddingTop: '1px',
      textAlign: 'center',
    },
    '& > span.glyphicon-ok:before': {
      content: '"" !important',
    },
    '& > span.glyphicon-ok:after': {
      content: '"\\E73E"',
      backgroundColor: '#0078d4',
      borderColor: '#0078d4',
      color: '#fff',
    },
  },
  '.selector-v2 .selector__no-data-message, .selector-v2 .selector__progress': {
    lineHeight: '38px',
    minHeight: 40,
    paddingLeft: 10,
  },
  '.selector-v2 .selector__no-data-message span, .selector-v2 .selector__progress span': {
    verticalAlign: 'middle',
  },
  '.selector-v2 .selector__no-data-message .progress__icon, .selector-v2 .selector__progress .progress__icon': {
    display: 'inline-block',
    backgroundRepeat: 'no-repeat',
    width: 40,
    height: 30,
    marginRight: 10,
  },
  '.selector-v2 .selector__filter-pill': {
    paddingLeft: 10,
    marginTop: 10,
  },
  '.selector-v2 .selector__filter-pill .pill-control': {
    display: 'inline-block',
    marginBottom: '0',
    verticalAlign: 'middle',
  },
  '.selector-v2 .selector__filter-pill .pill-control__list--links': {
    listStyle: 'none',
    marginBottom: '0',
    paddingLeft: '0',
  },
  '.selector-v2 .selector__filter-pill .pill-control__list-item--links': {
    float: 'left',
    marginLeft: 7,
  },
  '.selector-v2 .selector__filter-pill .pill-control__list-item--links a': {
    textDecoration: 'none',
  },
  '.selector-v2 .selector__filter-pill-label': {
    verticalAlign: 'middle',
  },
  '.selector-v2 .search-box-v2 .search-box__input-group': {
    position: 'relative',
    overflow: 'hidden',
  },
  '.selector-v2 .search-box-v2 .search-box__input': {
    padding: '3px 8px',
    paddingLeft: 33,
    border: '1px solid #bbbbbb',
    display: 'block',
    width: '100%',
    fontSize: '1em',
    '&:focus, &:hover': {
      border: '1px #0078d4 solid',
    },
  },
  '.selector-v2 .search-box-v2 .search-box__icon': {
    position: 'absolute',
    left: 6,
    fontSize: 12,
    color: '#605e5c',
    fontFamily: '"MsAds MDL2 Assets"',
    '&:hover': {
      cursor: 'pointer',
    },
    '&:before': {
      display: 'inline-block',
      fontWeight: 'normal',
      fontStyle: 'normal',
      textDecoration: 'inherit',
      speak: 'none',
      fontVariant: 'normal',
      textTransform: 'none',
      verticalAlign: 'top',
      lineHeight: 1,
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
      content: '"\\E721"',
      fontSize: 14,
      paddingTop: 4,
    },
    overflow: 'visible !important',
    textDecoration: 'none !important',
    background: 'none !important',
    top: 0,
    marginTop: 5,
  },
  '.selector-v2 .search-box-v2 .filter_search_icon_small': {
    '&:before': {
      fontSize: '14px',
    },
    height: '15px !important',
    display: 'inline-block !important',
    verticalAlign: 'text-top',
    marginTop: '5px',
  },
};
